//=====================================
//jquery
// import $ from 'jquery';
// window.$ = $;
// window.jQuery = $;
//=====================================
window.$ = window.jQuery = require('jquery');
global.$ = global.jQuery = require('jquery');
window.App = window.App  || {};


/////////////////////////
///AKAX POST
//////////////////////////
$(function(){

$(document).on('click', '.submit-ajax', function(event) {
   // ◎ボタンを無効化
  $(this).prop('disabled', true);
  $(this).find("span").html('処理中...');

  var $myform = $(this).closest("form");
  var form_id = $myform.attr("id");
  var formToken = $myform.find('input[name="formToken"]').val()
  $.ajax({
    url: '/contact.php',
    type: 'post',
    data: $myform.serialize(),
    dataType: 'json',
    success: function(response) {
        $(".error").empty();
        console.log(response);

        // ◎ボタンを有効化
        $('.submit-ajax').prop('disabled', false);
        $('.submit-ajax').find("span").html('送信する'); // 元のボタンのテキストに戻す

        if (response.errors) {
            var errors = response.errors;

            // 最初に表示されたエラーのIDにスクロール
            if (Object.keys(errors).length > 0) {
                var firstErrorKey = Object.keys(errors)[0];
                var firstErrorElement = $('#' + form_id + ' #error_' + firstErrorKey);  

                // エラーが非表示の場合、表示する
                firstErrorElement.show();

                // モーダル内であればモーダルのスクロール対象要素までスクロール
                if (firstErrorElement.length > 0) { // 要素が存在する場合のみ処理
                    if ($myform.find('.modal').length > 0) {
                        $('#' + form_id + ' .modal-body').animate({
                            scrollTop: firstErrorElement.offset().top - $('#' + form_id + ' .modal-body').offset().top + $('#' + form_id + ' .modal-body').scrollTop() - $('#' + form_id + ' .modal-header').height()
                        }, 500);
                    } else {
                        var scrollOffset = firstErrorElement.offset().top - $(document).scrollTop() - 80;
                        $('html, body').animate({
                            scrollTop: '+=' + scrollOffset + 'px'
                        }, 500);
                    }
                }
            }
            for (var key in errors) {
                var errorSelector = '#error_' + key;
                $(errorSelector).html(errors[key]);
                console.log(errorSelector + "です");
            }
        } else if (response.success) {
          var redirectUrl = '/contact_done.php';
          var postData = {
              referrer: encodeURIComponent(window.location.href),
              token: formToken
          };

          // Create a hidden form dynamically
          var hiddenForm = $('<form>', {
              action: redirectUrl,
              method: 'post',
              style: 'display:none;'
          });

          // Add the necessary inputs (referrer and token)
          for (var key in postData) {
              hiddenForm.append($('<input>', {
                  type: 'hidden',
                  name: key,
                  value: postData[key]
              }));
          }

          // Append the form to the body and submit it
          $('body').append(hiddenForm);
          hiddenForm.submit();
          }
    },
    error: function(error) {

        // ◎エラー時もボタンを有効化
        $('.submit-ajax').prop('disabled', false);
        $('.submit-ajax').find("span").html('送信する'); // 元のボタンのテキストに戻す

        console.log('Error:', error);
    }
});
});




});